import React, { memo } from "react";
import { Grid } from "@mui/material";
import CountingFactorBoxComponent from "./1_CardElements/CountingFactorBoxComponent";
import ExamTypeBoxComponent from "./1_CardElements/ExamTypeBoxComponent";
import CourseBoxComponent from "./1_CardElements/CourseBoxComponent";
import { useHusibuechContext } from "../../context/husibuechContext";
// import ErrorBox from "../CardElements/ErrorBox";

function LineTwo({
  type,
  selectedAssignmentCourse,
  onChangeAssignmentCourse,
  countingFactor,
  onChangeCountingFactor,
  countingFactorErr,
  assignmentExamTypeId,
  onChangeExamType,
}) {
  const { userCourses } = useHusibuechContext();
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
    >
      {/* Course */}
      <Grid xs={4}>
        <CourseBoxComponent
          restricted={false}
          selectedAssignmentCourse={selectedAssignmentCourse}
          userCourses={userCourses}
          change={onChangeAssignmentCourse}
        />
      </Grid>
      {/* Prüfungsdetails Container */}
      {type === "exam" && (
        <Grid xs={5}>
          <Grid container justifyContent="flex-start" spacing={1}>
            {/* Gewicht */}

            <Grid xs={5}>
              <CountingFactorBoxComponent
                restricted={false}
                countingFactor={countingFactor}
                change={onChangeCountingFactor}
                countingFactorErr={countingFactorErr}
              />
            </Grid>
            {/* Prüfungstyp */}
            <Grid xs={5}>
              <ExamTypeBoxComponent
                restricted={false}
                examTypeId={assignmentExamTypeId}
                change={onChangeExamType}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default memo(LineTwo);
